export const changeVirtualPage = (page, title) => {
    window.pSUPERFLY.virtualPage(page, title);
}



// WEBPACK FOOTER //
// ./src/utils/virtualPaging.js